const BRAND_NAME_ABBREVIATIONS: { [brandName: string]: string } = {
  economy: "E",
  premium: "P",
  business: "B",
};

const BRAND_NAME_PREFIX_PATTERN = /^(Economy|Premium|Business)([\s/-]+)(.+)$/i;
const BRAND_NAME_SUFFIX_PATTERN = /^(.+?)([\s/-]+)(Economy|Premium|Business)$/i;

interface BrandNameForTabLabels {
  accessibleName: string;
  visibleName: string;
}

const formatBrandNameForTab = (brandName: string): string => {
  const trimmedBrandName = brandName.trim();
  const prefixMatch = trimmedBrandName.match(BRAND_NAME_PREFIX_PATTERN);

  if (prefixMatch) {
    const [, prefix, separator, remainder] = prefixMatch;
    const abbreviation = BRAND_NAME_ABBREVIATIONS[prefix.toLowerCase()];

    return `${abbreviation}${separator}${remainder}`;
  }

  return trimmedBrandName.replace(
    BRAND_NAME_SUFFIX_PATTERN,
    (_match, remainder: string, separator: string, suffix: string) => {
      const abbreviation = BRAND_NAME_ABBREVIATIONS[suffix.toLowerCase()];

      return `${remainder}${separator}${abbreviation}`;
    }
  );
};

export const getBrandNameForTabLabels = (
  brandName: string
): BrandNameForTabLabels => {
  const fullName = brandName.trim();
  const visibleName = formatBrandNameForTab(fullName);

  return {
    accessibleName:
      visibleName === fullName ? fullName : `${visibleName} (${fullName})`,
    visibleName,
  };
};

export default formatBrandNameForTab;
